"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _LabelWithImage = _interopRequireWildcard(require("../LabelWithImage"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _ButtonRaw = _interopRequireDefault(require("@commerce-ui/core2/ButtonRaw"));
var _excluded = ["label", "image", "labelMode", "additionalLabel", "isArrowShown", "id"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var MenuArrowIcon = function MenuArrowIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.552 11.4l-2.976-2.976.848-.848L22.85 12l-4.425 4.424-.848-.848 2.976-2.976H2v-1.2h18.552z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.552 11.4l-2.976-2.976.848-.848L22.85 12l-4.425 4.424-.848-.848 2.976-2.976H2v-1.2h18.552z"
  }));
};
MenuArrowIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var defaultProps = {
  isArrowShown: true,
  labelMode: _LabelWithImage.LABEL_MODE.labelDefault
};
var MenuItemButton = function MenuItemButton(props) {
  var label = props.label,
    image = props.image,
    _props$labelMode = props.labelMode,
    labelMode = _props$labelMode === void 0 ? defaultProps.labelMode : _props$labelMode,
    additionalLabel = props.additionalLabel,
    _props$isArrowShown = props.isArrowShown,
    isArrowShown = _props$isArrowShown === void 0 ? defaultProps.isArrowShown : _props$isArrowShown,
    id = props.id,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return __jsx(_ButtonRaw["default"], restProps, __jsx(_Box["default"], {
    sx: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      "&:hover": {
        svg: {
          opacity: 1
        }
      },
      svg: {
        opacity: [1, null, null, 0],
        transition: "opacity .1s"
      }
    }
  }, __jsx(_LabelWithImage["default"], {
    label: label,
    id: id,
    image: image,
    labelMode: labelMode,
    additionalLabel: additionalLabel
  }), isArrowShown && __jsx(_Box["default"], {
    sx: {
      width: "24px",
      height: "24px",
      fill: "main"
    }
  }, __jsx(MenuArrowIcon, null))));
};
var _default = MenuItemButton;
exports["default"] = _default;